const helpers = require("@/services/helpers.js");
const gameSettings = require("@/gameSettings.js");

const USE_BACKEND = false;

const axios = USE_BACKEND
  ? require("axios").create({
    baseURL: "http://localhost:4000/",
  })
  : undefined;

// const elasticlunr = require('elasticlunr');
// const Joi = require('joi');

// const schema = Joi.object().keys({
//     username: Joi.string().alphanum().required(),
//     subject: Joi.string().required(),
//     message: Joi.string().max(500).required()
// });

// let index = elasticlunr(function () {
//     this.setRef('is')
//     this.addField('is')
//     this.addField('fr')
// });

const ALPHABET = [
  "a",
  "á",
  "b",
  "d",
  "ð",
  "e",
  "é",
  "f",
  "g",
  "h",
  "i",
  "í",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "ó",
  "p",
  "r",
  "s",
  "t",
  "u",
  "ú",
  "v",
  "x",
  "y",
  "ý",
  "þ",
  "æ",
  "ö",
  /* next are only for foreign words */ "c",
  "q",
  "w",
];

let VOCABULARY;
let ANALYSIS;
let WORDS_OF_CATEGORY;
let CATEGORIES;

function getVocabulary(req) {
  return VOCABULARY;
}

function getAnalysis(req) {
  return ANALYSIS;
}

function getCategories(req) {
  return CATEGORIES;
}

function getSomeWords(req) {
  // req: { "categories": ["aliments", "santé"], "size": 5 }
  const words = wordsOfCategories(req.categories);
  const randomWords = randomSelection(words, req.size);
  return randomWords;
}

function getWordsOfCategories() {
  return WORDS_OF_CATEGORY;
}

function wordsOfCategories(categories) {
  let ret = [];
  categories.forEach((c) => {
    const words = WORDS_OF_CATEGORY[c] || [];
    ret.push(...words);
  });
  return ret;
}

function randomSelection(originalWords, n) {
  let words = [].concat(originalWords);
  let ret = [];
  for (let ii = 0; ii < n; ii++) {
    if (words.length == 0) break;
    let idx = helpers.randomInteger(0, words.length - 1);
    ret.push(words[idx]);
    words.splice(idx, 1);
  }
  return ret;
}

// function randomInteger(min, max) {
//     return Math.floor(Math.random() * (max - min + 1)) + min;
// }

function getRandomLetters(n, ...excluded) {
  let ret = [];
  let alphabet = ALPHABET.filter((c) => !excluded.includes(c));
  for (let ii = 0; ii < n; ii++) {
    if (alphabet.length == 0) break;
    let idx = helpers.randomInteger(0, alphabet.length - 1);
    ret.push(alphabet[idx]);
    alphabet.splice(idx, 1);
  }
  return ret;
}

function search(req) {
  // // req: { "search": "niðurfall" }
  // const res = index.search(req.search);
  // console.log(res)
  // return res;
  if (!req.search || req.search.length <= 2) return [];

  let ret = [];
  for (const entry of VOCABULARY) {
    for (const word of entry.words) {
      Object.entries(word).forEach((arr) => {
        if (
          arr[0].indexOf(req.search) != -1 ||
          arr[1].indexOf(req.search) != -1
        ) {
          ret.push({ src: arr[0], target: arr[1] });
        }
      });
    }
  }
  return ret;
}

module.exports = {
  init: /*async*/ () => {
    // if (USE_BACKEND) {
    //     try {
    //         const vocabulary = await axios({
    //             method: 'get',
    //             url: '/vocabulary'
    //         });
    //         VOCABULARY = vocabulary.data;
    //     } catch (error) {
    //         console.log(error)
    //         VOCABULARY = []
    //     }
    // } else {
    if (!VOCABULARY) {
      VOCABULARY = require("./vocabulary.json");
    }
    if (!ANALYSIS) {
      ANALYSIS = require("./analysis.json");
    }
    // }

    let onlyMultiword = gameSettings.onlyMultiword;
    let onlyEg = gameSettings.onlyEg;

    WORDS_OF_CATEGORY = {};
    for (const entry of VOCABULARY) {
      WORDS_OF_CATEGORY[entry.category] = entry.words;
      console.log(
        `Entire category ${entry.category}: ${entry.words.length} words`
      );
    }

    CATEGORIES = Object.keys(WORDS_OF_CATEGORY);
  },
  getVocabulary,
  getAnalysis,
  getCategories,
  getWordsOfCategories,
  getSomeWords,
  getRandomLetters,
  search,

  ALPHABET,
};
